export default "__VITE_ASSET__bUpPbZ0w__"